interface Permiso {
    id: number;
    nombre: string;
    url_menu: string;
    icon: string;
    padreId: number | null;
    orden: number;
    isVisible: boolean;
    selected?: boolean;
}

export const getRouteNameFromURL = (url_menu: string, arr: Permiso[]): string => {
    const permisos: Permiso[] = JSON.parse(localStorage.getItem('permisos') || '[]');
    let name: string;
    if (permisos.length) {
        name = permisos.find((p: Permiso) => p.url_menu === url_menu)?.nombre.replace(/ /g, '-') || '';
    } else {
        name = arr.find((p: Permiso) => p.url_menu === url_menu)?.nombre.replace(/ /g, '-') || '';
    }

    return name;
};
